import React, { memo, useState } from "react";
import styles from "./VerifyPhoneNumberOtpForm.module.scss";
import { BounceLoader } from "react-spinners";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";
import TimerButton from "../../../../../common/components/timer-button/TimerButton";

type Props = {
	onResendOtp: () => Promise<void>;
	onVerifyOtp: (otp: string) => Promise<void>;
	onCloseDialog: () => void;
};

const VerifyPhoneNumberOtpForm: React.FC<Props> = memo((props: Props) => {
	const { onResendOtp, onVerifyOtp, onCloseDialog } = props;

	const otpLength = 6;
	const [errorMessage, setErrorMessage] = useState('');

	const [otp, setOtp] = useState("");
	const [loading, setLoading] = useState(false);

	const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

	const validateOtp = (otp: string) => {
		if (otp.length === otpLength) {
			setErrorMessage('');
			return true;
		}
		else {
			setErrorMessage('Please enter the complete OTP');
			return false;
		}
	}

	const handleChange = (otp: string) => {
		setOtp(otp);
		if (isSubmitted) {
			validateOtp(otp);
		}
	}


	const handleVerifyButton = () => {
		handleVerify(otp);
	};

	const handleResendOtp = async () => {
		try {
			await onResendOtp();

			toast.success("OTP sent successfully");
		} catch (error) {
			toast.error("Failed to resend OTP. Please try again.");
		}
	};

	const handleVerify = async (otp: string) => {
		setLoading(true);

		try {
			setIsSubmitted(true);
			if (!validateOtp(otp)) {
				return;
			}
			await onVerifyOtp(otp);
		} catch (error) {
			toast.error("Invalid OTP. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				OTP
				<div className={`link`}>Need Help?</div>
				<div>
				<svg className={styles.closeButton} width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onCloseDialog}>
					<path d="M15.75 15.75L9 9M9 9L2.25 2.25M9 9L15.75 2.25M9 9L2.25 15.75" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
				</svg>
			</div>
			</div>
			<div className={styles.contentContainer}>
				<div className={styles.inputLabel}>Enter the code we've sent by mail to you</div>
				<OtpInput value={otp} onChange={handleChange} numInputs={otpLength} containerStyle={styles.otpContainer} renderInput={props => <input {...props} />} />
				{errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
				<button className={`standardButton ${styles.verifyButton}`} onClick={handleVerifyButton}>
					{loading ? <BounceLoader color="#DE841B" size={25} /> : "Verify"}
				</button>
				<p><b>Important: </b>If you do not receive the email in your inbox, please check your spam or junk folder as it may have been filtered by your email provider.</p>
				<div className={styles.resendContainer}>
					Didn't receive the code? <TimerButton timerLength={60} onClick={handleResendOtp} />
				</div>
			</div>
		</div>
	);
});

export default VerifyPhoneNumberOtpForm;
